export const PRO_FEATURES = Object.freeze({
  ARTIST_TECH_RIDER: "artistTechRider",
  ARTIST_MULTIPLE_PAGES: "artistMultiplePages",
  EVENT_TICKET_PROVIDER: "eventTicketProvider",
  VENUE_STAGE_PLOT: "venueStagePlot",
  VENUE_MULTIPLE_PAGES: "venueMultiplePages",
  STUDIO_LAYOUT: "studioLayout",
  STUDIO_MULTIPLE_PAGES: "studioMultiplePages",
  INBOX_FILE_UPLOAD: "inboxFileUpload",
  APPLY_TO_GIG: "applyToGig",
  CONTACT_VENUE: "contactVenue",
  CONTACT_STUDIO: "contactStudio",
  REQUEST_STUDIO_SESSION: "requestStudioSession",
});

export const PROFILE_LIMITS = Object.freeze({
  FREE: 1,
  PRO: 5,
});

export function hasProAccount(user) {
  const plan = user?.plan || user?.subscription?.plan || user?.subscriptionTier;
  return String(plan || "").toUpperCase() === "PRO" || user?.isPro === true;
}

export function profileLimitFor(user) {
  return hasProAccount(user) ? PROFILE_LIMITS.PRO : PROFILE_LIMITS.FREE;
}

export function canJoinProWaitlist(user) {
  return Boolean(user?.role) && user.role !== "GUEST";
}

export function canApplyToGig(user) {
  return user?.role === "ARTIST" && hasProAccount(user);
}

export function canContactVenue(user) {
  return Boolean(user?.role);
}

export function canContactStudio(user) {
  return Boolean(user?.role);
}

export function canRequestStudioSession(user) {
  return user?.role === "ARTIST" && hasProAccount(user);
}
